<span *ngIf="daysToDday">
  <span id="days"> {{daysToDday}} </span>day<span *ngIf="daysToDday > 1">s</span>
</span>
<span id="hours"> {{hoursToDday | number:"2.0-0"}} </span>:
<span id="minutes"> {{minutesToDday | number:"2.0-0"}} </span>:
<span id="seconds"> {{secondsToDday | number:"2.0-0"}} </span>
